import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft, Printer, ExternalLink } from "lucide-react";
import { API } from "../../lib/api";

/**
 * Standalone preview page for the day-sheet PDF. Wraps the backend PDF in
 * an iframe so the user always has a clear «Voltar» button — opening the
 * PDF in the same tab (which used to happen on iOS / PWAs) trapped the
 * user without a way to return to the calendar.
 */
export default function AdminDaySheet() {
  const { date } = useParams();
  const nav = useNavigate();
  const pdfUrl = `${API}/admin/day-sheet/${date}/pdf`;

  return (
    <div className="space-y-5" data-testid="admin-day-sheet">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <button
          onClick={() => nav(-1)}
          className="btn-ghost-gold px-4 py-2 text-xs uppercase tracking-widest inline-flex items-center gap-2"
          data-testid="day-sheet-back"
        >
          <ArrowLeft size={14} /> Voltar à agenda
        </button>
        <div>
          <div className="eyebrow">Folha do dia</div>
          <h1 className="font-display text-3xl md:text-4xl">{date}</h1>
        </div>
        <div className="flex items-center gap-2">
          <a
            href={pdfUrl}
            target="_blank"
            rel="noreferrer"
            className="btn-ghost-gold px-4 py-2 text-xs uppercase tracking-widest inline-flex items-center gap-2"
            data-testid="day-sheet-open-new-tab"
            title="Abre o PDF noutro separador"
          >
            <ExternalLink size={14} /> Abrir noutro separador
          </a>
          <button
            onClick={() => {
              const f = document.getElementById("day-sheet-frame");
              if (f && f.contentWindow) f.contentWindow.focus();
              if (f && f.contentWindow && f.contentWindow.print) {
                f.contentWindow.print();
              } else {
                window.open(pdfUrl, "_blank", "noopener,noreferrer");
              }
            }}
            className="btn-gold px-4 py-2 text-xs uppercase tracking-widest inline-flex items-center gap-2"
            data-testid="day-sheet-print"
          >
            <Printer size={14} /> Imprimir
          </button>
        </div>
      </div>

      <div className="lux-card overflow-hidden" style={{ height: "calc(100vh - 220px)", minHeight: 520 }}>
        <iframe
          id="day-sheet-frame"
          title={`Folha do dia ${date}`}
          src={pdfUrl}
          className="w-full h-full"
          style={{ border: 0, background: "#fdfbf7" }}
          data-testid="day-sheet-iframe"
        />
      </div>

      <p className="text-xs text-[#a0b2af]" data-testid="day-sheet-hint">
        Se a pré-visualização não carregar no seu telemóvel, toque em
        «Abrir noutro separador» e depois use a seta «voltar» do navegador
        para regressar a esta página.
      </p>
    </div>
  );
}
